// extracted by mini-css-extract-plugin
module.exports = {"s1glbvt1":"s1glbvt1"};